import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';

import {
  RsaSearchDisplayPathInitModel,
  RsaSearchDisplayPathInitVariables,
  RsaSearchDisplayPathModel,
  RsaSearchDisplayPathVariables,
} from '../../../../../models/google-template/rsa-search-display-path.interface';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { BaseComponent } from '../../../common/BaseComponent';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-rsa-search-display-path',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './rsa-search-display-path.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './rsa-search-display-path.component.scss'
})
export class GoogleRsaSearchDisplayPathComponent extends BaseComponent implements OnInit {
  //@ input
  @Input() block: RsaSearchDisplayPathModel = new RsaSearchDisplayPathInitModel();
  @Input() isPreview = false;
  //@ output
  @Output() blockData = new EventEmitter<any>(); // Event emitter to send data to the parent
  @Output() removeBlockEvent = new EventEmitter<string | null>(); // New EventEmitter for remove

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new RsaSearchDisplayPathInitVariables()
    }
  }

  //@ placeholders
  firstPartPlaceholder: string = 'Enter first part of display path';
  secondPartPlaceholder: string = 'Enter first part of display path';

  //@remove
  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  //@onChange
  onChange(value: any, fieldName: keyof RsaSearchDisplayPathVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof RsaSearchDisplayPathVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
